import { useEffect } from 'react';

import { di } from 'react-magnetic-di';
import { useQueryParam } from 'react-resource-router-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';

export type HandoffType = 'agent' | 'app' | 'automation';

export const useSaHandoffTracker = (handoffType: HandoffType) => {
	di(useAnalyticsEvents, useQueryParam);

	const [saHandoff, setSaHandoff] = useQueryParam('saHandoff');
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (saHandoff !== 'true') {
			return;
		}

		// Clear the query param after tracking to avoid duplicate events
		setSaHandoff(undefined, 'replace');

		// Fire analytics event for successful handoff landing
		fireTrackAnalytics(createAnalyticsEvent({}), 'solutionArchitectHandoff success', {
			name: handoffType,
		});
	}, [saHandoff, setSaHandoff, handoffType, createAnalyticsEvent]);
};
